



























































































































import { TableColumn } from "../../models/UI/TableColumn";
import VueTagsInput from "@johmun/vue-tags-input";
import { Config } from "../../utils/Config";
import moment from "moment";

export default {
    name: "TableFilters",
    components: { VueTagsInput },
    props: {
        columns: Array,
    },
    data() {
        return {
            selectedFilters: [],
            filterToAdd: null,
            filterValue: null,
            ColumnType: TableColumn.ColumnType,
            vueMultiselectParams: Config.vueMultiselectParams,
            datepickerAttributes: [
                {
                    key: "today",
                    dot: true,
                    dates: new Date(),
                },
            ],
            tag: "",
            tags: [],
        };
    },
    created() {
        let self = this;
        _.filter(self.columns, { default_filter: true }).forEach(function (
            col
        ) {
            self.filterToAdd = col;
            self.filterValue = col.default_value;
            self.tags = col.default_value;
            self.addFilter();
        });
    },
    methods: {
        resetNewFilter(): void {
            this.filterValue = null;
            this.tag = "";
            this.tags = [];
        },
        addFilter(): void {
            let newFilter = {
                fieldName: this.filterToAdd.id,
                value: this.filterValue,
                name: this.filterToAdd.name,
                type: this.filterToAdd.type,
            };
            if (this.filterToAdd.type === TableColumn.ColumnType.tags) {
                newFilter.value = this.tags;
            }
            let existingFilter = _.find(this.selectedFilters, {
                fieldName: newFilter.fieldName,
            });
            if (existingFilter) {
                if (
                    (!newFilter.value &&
                        !newFilter.type === TableColumn.ColumnType.boolean) ||
                    (_.isArray(newFilter.value) &&
                        _.isEmpty(newFilter.value)) ||
                    (newFilter.type === TableColumn.ColumnType.text &&
                        newFilter.value === "")
                ) {
                    this.removeFilter(existingFilter);
                } else {
                    existingFilter.value = newFilter.value;
                }
            } else if (
                !(_.isArray(newFilter.value) && _.isEmpty(newFilter.value))
            ) {
                this.selectedFilters.push(newFilter);
            }
        },
        removeFilter(filter): void {
            _.pull(this.selectedFilters, filter);
            this.onFiltersUpdate();
            if (this.filterToAdd.id === filter.fieldName) {
                this.resetNewFilter();
            }
            this.$forceUpdate();
        },
        // UI
        isOfType(type: TableColumn.ColumnType): boolean {
            return this.filterToAdd && this.filterToAdd.type === type;
        },
        filterValueStr(filter): string {
            if (filter.type === TableColumn.ColumnType.boolean) {
                return filter.value ? "Oui" : "Non";
            } else if (filter.type === TableColumn.ColumnType.text) {
                return filter.value;
            } else if (filter.type === TableColumn.ColumnType.option) {
                return filter.value.name;
            } else if (filter.type === TableColumn.ColumnType.date) {
                return moment(filter.value).format("DD/MM/YYYY");
            } else if (filter.type === TableColumn.ColumnType.month_year) {
                return moment(filter.value).format("MM/YYYY");
            } else if (filter.type === TableColumn.ColumnType.date_range) {
                return (
                    moment(filter.value.start).format("DD/MM/YYYY") +
                    " - " +
                    moment(filter.value.end).format("DD/MM/YYYY")
                );
            } else if (filter.type === TableColumn.ColumnType.tags) {
                return _.chain(<Array<any>>filter.value)
                    .map("text")
                    .join(", ")
                    .value();
            }
        },
        availableColumns(): Array<any> {
            let self = this;
            return _.filter(self.columns, function (c) {
                return !!c.type && !c.hidden;
                //return !_.some(self.selectedFilters, { fieldName : c.id })
            });
        },
        // Events
        onTagsChanged(newTags): void {
            this.tags = newTags;
            this.addFilter();
        },
        onFiltersUpdate(): void {
            let filters = {};
            _.forEach(this.selectedFilters, function (f) {
                if (f.type === TableColumn.ColumnType.text) {
                    filters[f.fieldName] = f.value;
                } else if (f.type === TableColumn.ColumnType.date) {
                    filters[f.fieldName] = moment(f.value).format("YYYY-MM-DD");
                } else if (f.type === TableColumn.ColumnType.month_year) {
                    // Format as YYYY-MM-01 to get the first day of the month
                    filters[f.fieldName] = moment(f.value)
                        .startOf("month")
                        .format("YYYY-MM-DD");
                } else if (f.type === TableColumn.ColumnType.date_range) {
                    filters[f.fieldName + "From"] = moment(
                        f.value.start
                    ).format("YYYY-MM-DD");
                    filters[f.fieldName + "To"] = moment(f.value.end).format(
                        "YYYY-MM-DD"
                    );
                } else if (f.type === TableColumn.ColumnType.tags) {
                    filters[f.fieldName] = _.chain(<Array<any>>f.value)
                        .map(function (o) {
                            if (_.isInteger(o.id)) {
                                return o.id;
                            } else if (o.ids && o.ids.length > 0) {
                                return o.ids;
                            }
                        })
                        .join(",")
                        .value();
                } else if (f.type === TableColumn.ColumnType.option) {
                    filters[f.fieldName] = f.value.id;
                } else if (f.type === TableColumn.ColumnType.boolean) {
                    filters[f.fieldName] = f.value;
                }
            });
            this.$emit("update-filters", filters);
        },
    },
    computed: {
        filteredItems() {
            if (this.filterToAdd && this.filterToAdd.options) {
                return this.filterToAdd.options.filter((i) => {
                    return (
                        i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !==
                        -1
                    );
                });
            }
        },
    },
    watch: {
        selectedFilters: {
            deep: true,
            handler: function () {
                this.onFiltersUpdate();
            },
        },
        filterValue: {
            deep: true,
            handler: function () {
                if (!_.isNull(this.filterValue)) {
                    this.addFilter();
                }
            },
        },
        filterToAdd: {
            deep: true,
            handler: function () {
                this.resetNewFilter();
            },
        },
    },
};
